import "./BaseMessage_module.css";
const BaseMessage_module = {
    baseMessage: "baseMessage__01cbb1646ac9382a"
};
export { BaseMessage_module as default };
